import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../../core/design-system/components/Text';
import './styles.css';

const ActiveFeedFiltersBanner = ({ maxDistance, userInterests }) => {
  const { t } = useTranslation('common');

  // Formater les intérêts de l'utilisateur en une chaîne lisible
  const formattedInterests = useMemo(() => {
    if (!userInterests || !Array.isArray(userInterests) || userInterests.length === 0) {
      return t('activeFilters.noCategories');
    }
    
    return userInterests.join(', ');
  }, [userInterests, t]);

  return (
    <div className="active-filters-banner">
      <Text variant="body2" className="active-filters-item">
        {t('activeFilters.radius', { distance: maxDistance || 50 })} • {t('activeFilters.categories', { categories: formattedInterests })}
      </Text>
    </div>
  );
};

export default ActiveFeedFiltersBanner; 